import * as types from "./mutation-types";
import { parceiro_empty } from "./getters";
import _ from "lodash";

export default {
  [types.SET_parceiroS](state, payload) {
    state.parceiros = payload;
  },
  [types.SET_parceiro](state, payload) {
    payload = Object.assign({}, parceiro_empty(), payload);
    state.parceiro = payload;
  },
  [types.SET_PAGINATION](state, payload) {
    state.pagination = payload;
  },
};
